var map = {
	"./details-bonds.svg": "dcaa",
	"./details-chf.svg": "b804",
	"./details-eur.svg": "a955",
	"./details-europe.svg": "7113",
	"./details-liquidity.svg": "0574",
	"./details-north-america.svg": "cf6a",
	"./details-other-asset.svg": "4285",
	"./details-other-currency.svg": "8245",
	"./details-other-region.svg": "7004",
	"./details-shares.svg": "d3fc",
	"./details-switzerland.svg": "c575",
	"./details-usd.svg": "7d74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80eb";